import { GraphQLClient } from 'graphql-request';

const isProdEnv = process.env.NODE_ENV === 'production';
const OL_BASE_ENDPOINT = isProdEnv ? 'https://ol.na.climate.com/v2/graphql' : '/v2/graphql';
const credentials = 'include';

const graphQLClient = new GraphQLClient(OL_BASE_ENDPOINT, { credentials });
const rawGraphQLClient = new GraphQLClient(OL_BASE_ENDPOINT, { credentials, errorPolicy: 'all' });

const getHeaders = () => {
  return {
    'Accept': 'application/json',
    'x-http-caller-id': process.env.npm_package_name,
    'x-http-caller-version': process.env.npm_package_version,
    'x-data-origin': 'dfp',
    'x-data-legitimacy': 'LEGITIMATE'
  };
};

type Variables = { [x: string]: unknown };
/**
 * Returns the data from OL, or throws if there are errors, ignoring any data. 
 * @param query OL query
 * @param variables Variables of the query
 */
export const orchestrationLayerFetcher = <T>(query: string, variables?: Variables) => {
  return graphQLClient.request<T>(query, variables, getHeaders());
};

/**
 * Returns the data from OL, and the errors, if there is any, as well as the 
 * status code, headers, and extensions. 
 * @param query OL query
 * @param variables Variables of the query
 */
export const rawOrchestrationLayerFetcher = <T>(query: string, variables?: Variables) => {
  return rawGraphQLClient.rawRequest<T>(query, variables, getHeaders());
};
